import { render, staticRenderFns } from "./bannerui.vue?vue&type=template&id=bfe69230&scoped=true&"
import script from "./bannerui.vue?vue&type=script&lang=js&"
export * from "./bannerui.vue?vue&type=script&lang=js&"
import style0 from "./bannerui.vue?vue&type=style&index=0&id=bfe69230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe69230",
  null
  
)

export default component.exports